import { useEffect } from 'react';
import { href, navigate, useLocation } from '../../app/router';

/**
 * `/signup` is gone (P17: access is by invitation): an old link or bookmark lands on the sign-in page, its `next`
 * destination kept (the login page checks it with `safeNext`).
 */
export function SignupRedirect() {
  const { search } = useLocation();
  useEffect(() => {
    const next = new URLSearchParams(search).get('next');
    navigate(href('login', {}, next ? { next } : undefined), { replace: true });
  }, [search]);
  return null;
}
